module.exports = __webpack_public_path__ + "img/619.105df2f5.png";